// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/src/ClientStyleContext.tsx"
);
import.meta.hot.lastModified = "1744085769114.8093";
}
// REMIX HMR END

import * as React from 'react';

export interface ClientStyleContextData {
  reset: () => void;
}

export default React.createContext<ClientStyleContextData>({
  reset: () => {},
});
